/**
 * Environment configuration. Vite injects VITE_* at build time.
 * - Production: uses .env (or .env.production)
 * - Development: uses .env.development when running `npm run dev` or `npm run build:dev`
 */
export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ?? "https://xpifuwgmwgtawevpeskr.supabase.co";
export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhwaWZ1d2dtd2d0YXdldnBlc2tyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4ODY0NzQsImV4cCI6MjA4ODQ2MjQ3NH0.3fQY_BL9BQ3FJXb49NGPpAVji9SieFZfvi2tjdJh704";

export const IS_DEV = import.meta.env.DEV;
